var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{attrs:{"init":{
      height: 200,
      menubar: false,
      statusbar: false,
      plugins: 'paste, lists',
      paste_as_text: true,
      placeholder: _vm.placeholder || '',
      toolbar:
        'bold italic | \ alignleft aligncenter alignright alignjustify | \ bullist numlist outdent indent',
    }},model:{value:(_vm.computedContent),callback:function ($$v) {_vm.computedContent=$$v},expression:"computedContent"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":_vm.inputname},domProps:{"value":_vm.content}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }